import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import type { Currency } from '@ps/web-core-enums';
import type { TrackedTranslation, TranslationTag } from '@ps/web-core-intl';
import { StarsButton, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';

import TicketIcon from '../../assets/icons/ticket.svg';
import type { StepKey } from '../../types';

import Banner from './Banner/Banner';
import { TXTCLI_BUY_IN, TXTCLI_Players, TXTCLI_Step_N0 } from './Tile.messages.json';
import styles from './Tile.scss';

export interface TileProps {
  stepNumber: number;
  stepKey: StepKey;
  buyIn: number | string;
  enrolled: number | string;
  prize: React.ReactNode;
  prizeLabel: TranslationTag;
  status: string;
  statusLoading?: boolean;
  stateClassName?: string;
  currency: Currency;
  onRegister: () => void;
  bannerClassName: string;
  playButtonTranslation: TrackedTranslation;
  isPlayButtonDisabled?: boolean;
}

const Tile: React.FC<TileProps> = ({
  stepKey,
  stepNumber,
  buyIn,
  enrolled,
  prize,
  prizeLabel,
  currency,
  stateClassName,
  onRegister,
  status,
  statusLoading,
  bannerClassName,
  playButtonTranslation,
  isPlayButtonDisabled = false
}) => (
  <div className={classNames(styles.tileWrapper, styles[`step${stepNumber}`])} key={stepKey}>
    <div className={styles.bannerContainer}>
      <div className={styles.stepLabel}>
        <Translation {...TXTCLI_Step_N0} values={{ 0: '' }} tagName="div" />
        <div>{stepNumber}</div>
      </div>
      <Banner stepKey={stepKey} bannerClassName={bannerClassName} />
    </div>
    <div className={styles.stepSpacer} />
    <div className={styles.infoBox}>
      <div className={classNames(styles.state, stateClassName)}>
        {statusLoading ? <Skeleton variant="rect" width="100%" animation="wave" /> : status}
      </div>
      <div className={classNames(styles.buyIn, styles.tournInfo)}>
        <div className={styles.buyInLabel}>
          <Translation {...TXTCLI_BUY_IN} />
        </div>
        {/* TODO: "narrowSymbol" brakes hydration in Cypress. Find the reason and remove suppressHydrationWarning */}
        <div suppressHydrationWarning>
          {typeof buyIn === 'number' ? (
            <>
              <CurrencyAmount
                value={buyIn}
                currency={currency as Currency}
                minimumFractionDigits={buyIn % 100 !== 0 ? 2 : 0}
                currencyDisplay="narrowSymbol"
              />
              {' / '}
              <TicketIcon />
            </>
          ) : (
            buyIn
          )}
        </div>
      </div>
      <div className={classNames(styles.buyIn, styles.tournInfo)}>
        <Translation {...TXTCLI_Players} tagName="div" />
        <div>{enrolled}</div>
      </div>
      <div className={classNames(styles.buyIn, styles.tournInfo)}>
        <Translation {...prizeLabel} tagName="div" />
        <div className={styles.topPrizeValue}>{prize}</div>
      </div>
      <StarsButton
        className={styles.actionButton}
        translation={playButtonTranslation}
        variant="secondary"
        inverse={true}
        onClick={onRegister}
        disabled={isPlayButtonDisabled}
      />
    </div>
  </div>
);
export default Tile;
